import Vue from 'vue'
import store from '~/js/store'

const telephone = new Vue({
    el: '.js-telephone',
    data: {
        phone: "8 800 550-75-06",
        phoneUrl: "tel:+78005507506"
    },
    computed: {
        showModal () {
            return store.state.showModal;
        }
    },
    mounted(){
        this.$el.classList.remove("is-prerender");
        store.watch(store.getters.getLocationPhone, phone => {
            this.phone = phone;
        });

        store.watch(store.getters.getLocationPhoneUrl, phoneUrl => {
            this.phoneUrl = phoneUrl;
        });
    }
});